<template>
    <div class="error-banner">
        {{ message }}
    </div>
</template>

<script>
export default {
    props: {
        message: String,
    },
};
</script>

<style lang="scss" scoped>
    .error-banner {
        width: 100%;
        padding: $spacing-100 $spacing-200;
        border: 1px solid $color-red;
        border-radius: $spacing-100;
        background-color: $color-red-lightest;
    }
</style>
